exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-popover {\n  position: absolute;\n  background: #fff;\n  min-width: 150px;\n  border-radius: 2px;\n  border: 1px solid #d1dbe5;\n  z-index: 2000;\n  font-size: 12px;\n}\n.m-popover .popper__arrow {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n  border-width: 6px;\n  top: -6px;\n  left: 50%;\n  margin-left: -3px;\n  border-top-width: 0;\n  border-bottom-color: #d1dbe5;\n}\n.m-popover .popper__arrow::after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n  top: -5px;\n  margin-left: -6px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n  content: \" \";\n  border-width: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1cae82","@brand-primary-tap":"#1DA57A"}}!./src/components/popover/index.less
// module id = 535
// module chunks = 0